// extracted by mini-css-extract-plugin
module.exports = {"container":"V5Notice-module--container--1Bbri","header":"V5Notice-module--header--2InO0","content":"V5Notice-module--content--FRp1x"};